import React from "react";
// import PropTypes from "prop-types";
// --- Import Components
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import SubscriptionsList from "./SubscriptionsList/SubscriptionsList";
// --- Import Styles
import "./Subscriptions.sass";

function Subscriptions() {
  return (
    <article className="subscriptions">
      <section className="section-title subscriptions__title">
        <h3>My subscriptions</h3>
      </section>
      <ErrorBoundary
        classWrapper="payment-section__error"
        classText="payment-section__error-text"
      >
        <SubscriptionsList />
      </ErrorBoundary>
    </article>
  );
}

Subscriptions.propTypes = {};

export default Subscriptions;
